import React from "react"
import { Tabs, TabList, Tab, Text, TabPanels, TabIndicator, TabPanel } from "@chakra-ui/react"
import BluePanel from "./BluePanel"
import PinkPanel from "./PinkPanel"
import ToysPanel from "./ToysPanel"

const KidsTab: React.FC = () => {
  return (
    <Tabs>
      <TabList color='gray.500'>
        <Tab _selected={{ color: '#37A75B' }}>
          <Text fontSize='md' fontWeight='semibold'>
            Blue
          </Text>
        </Tab>

        <Tab _selected={{ color: '#37A75B' }}>
          <Text fontSize='md' fontWeight='semibold'>
            Pink
          </Text>
        </Tab>

        <Tab _selected={{ color: '#37A75B' }}>
          <Text fontSize='md' fontWeight='semibold'>
            Toys
          </Text>
        </Tab>
      </TabList>

      <TabIndicator
        mt="-1.5px"
        height="2px"
        bg="#37A75B"
        borderRadius="1px"
      />

      <TabPanels>
        <TabPanel p={0}>
          <BluePanel />
        </TabPanel>

        <TabPanel p={0}>
          <PinkPanel />
        </TabPanel>

        <TabPanel p={0}>
          <ToysPanel />
        </TabPanel>
      </TabPanels>
    </Tabs>
  )
}

export default KidsTab